import { Component, Input } from '@angular/core';
import { SubmittedClaimDetails } from '../submittedClaim';

@Component({
  selector: 'lib-claim-submission-summary',
  templateUrl: './claim-submission-summary.component.html',
  styleUrls: ['./claim-submission-summary.component.scss'],
})
export class ClaimSubmissionSummaryComponent {
  @Input() config;
  @Input() claimNumber: string;
  @Input() claimId: string;
  @Input() submittedClaimContext: SubmittedClaimDetails;
}
